import ListOfLinks from "../ListOfLinks";
import { staticSubjectsData } from "../../util/data/subjects";

const SubjectLinks = ({ subjectAndLevel }) => {
  {
    if (!subjectAndLevel.subject) {
      return null;
    }
    const subject = staticSubjectsData.find(
      (subject) => subject.urlSubject === subjectAndLevel.subject
    );
    if (!subject || !subject.levels) {
      return null;
    }

    const links = subject.levels
      .map((level) => {
        if (level.urlLevel === subjectAndLevel.level) {
          return null;
        }
        return {
          name: getLinkName(subject, level),
          url: getHref(subject, level),
        };
      })
      .filter((removeNulls) => removeNulls);
    return <ListOfLinks name={getTitleName(subject)} links={links} />;
  }
};

function getLinkName(subject, level) {
  return level.level + " " + subject.subject + " tutors";
}

function getTitleName(subject) {
  return "Levels available for " + subject.subject + " tutors";
}

function getHref(subject, level) {
  return "/view-tutors/" + subject.urlSubject + "/" + level.urlLevel + "/";
}

export default SubjectLinks;
